import { defaultValue, usePatchFilter, useResetFilter, useFilter } from './context';
import ContentBoardStyled from '../../../components/ContentBoardStyled';
import StyledBoardHeader from '../../../components/StyledBoardHeader';
import SelectInput from '../../../components/Inputs/SelectInput';
import { FiltersWrap } from '../../../components/Inputs/styles';
import useDealers from '../../../api/useDealers';
import { isEqual } from 'lodash';
import React from 'react';

export default function () {
  const patchFilter = usePatchFilter();
  const resetFilter = useResetFilter();
  const { dealers } = useDealers('');
  const filter = useFilter();

  return (
    <ContentBoardStyled css={{ minHeight: '130px', marginLeft: 0, marginTop: 0 }}>
      <StyledBoardHeader
        button={{
          name: 'Reset',
          handler: resetFilter
        }}
        disabledButton={isEqual(defaultValue, filter)}
      >
        FILTER
      </StyledBoardHeader>

      <FiltersWrap p={3}>
        <SelectInput
          single={1}
          label={'Image source'}
          clearOption={1}
          data={{
            items: [
              { label: 'Lotflo', value: 'LOTFLO' },
              { label: 'Homenet', value: 'HOMENET' }
            ]
          }}
          keys={{ id: 'value', name: 'label' }}
          selectedItems={filter.source}
          setSelectedItems={(source) => patchFilter({ source })}
        />
        <SelectInput
          label={'Locations'}
          data={dealers}
          keys={{ id: 'hmsId', name: 'name', type: 'locations' }}
          selectedItems={filter.dealers}
          setSelectedItems={(dealers) => {
            patchFilter({ dealers: dealers.filter((d) => Boolean(d)) });
          }}
        />
        <SelectInput
          label={'Fail Reasons'}
          data={{
            items: [
              { label: 'AI VIN AWARE', value: 'VISUAL_MATCH' },
              { label: 'VIN', value: 'VIN' },
              { label: 'AI AUTHENTICITY:', value: 'ORIGINAL_PHOTO' },
              { label: 'GEOPOSITION', value: 'GEOPOSITION' },
              { label: 'DATE TIME', value: 'DATETIME' },
              { label: 'CAPTURE CODE', value: 'CAPTURE_CODE' }
            ]
          }}
          keys={{ id: 'value', name: 'label' }}
          selectedItems={filter.failReasons}
          setSelectedItems={(failReasons) => {
            patchFilter({ failReasons });
          }}
        />
      </FiltersWrap>
    </ContentBoardStyled>
  );
}
